import React from 'react';

import BaseListItem from 'flow/components/ui-components/BaseListItem';
import useAppContext from 'flow/hooks/useAppContext';

const ConnectedServicesInstructions = () => {
    const { i18next } = useAppContext();

    return (
        <BaseListItem>
            <div className="mx-3 w-full bg-gray-100 p-3 font-bold text-gray-600">
                {i18next.t('ConnectedServices.Instructions')}
            </div>
        </BaseListItem>
    );
};

export default ConnectedServicesInstructions;
